import { useState, useEffect } from "react";
import styled from "styled-components";
import LoadingBar from "./LoadingBar";
import Logo from "./Logo";
import Pages from "./Pages";
import Spinner from "../Spinner";
import { useAppSelector, useCustomImage, useConfig } from "../../hooks";

const Styled = styled.div`
    background-size: cover;
    width: 100%;
    height 100%;
    background-position: center;
    background-image: url("ui/game/images/en/loading-screen/background.webp");
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    z-index: 1;

    ${(props: any) => props.customStyle || ""}
  ` as any;

const LoadingScreen: React.FC = () => {
  const { loadingScreen } = useAppSelector((state) => state);
  const { loadingScreen: config } = useConfig();
  const [isLoaded, setIsLoaded] = useState(false);

  const srcs = [
    useCustomImage(config.background.image),
    useCustomImage(config.logos.game),
    useCustomImage(config.logos.elysium),
    useCustomImage(config.logos.swintt),
  ];

  useEffect(() => {
    let count = 0;
    srcs.forEach((src) => {
      const image = new Image();
      const loadHandler = () => {
        count = count + 1;
        setIsLoaded(count === srcs.length);
      };
      image.onload = loadHandler;
      image.onerror = loadHandler;
      image.src = src;
    });
  }, []);

  if (!loadingScreen.visible) return null;

  if (!isLoaded) {
    return (
      <Spinner size={80} stroke={3} name="loading" full={true} visible={true} />
    );
  } else {
    return (
      <Styled customStyle={config.style}>
        <Logo name="elysium" position="top" />
        <Pages slides={config.slides}/>
        <LoadingBar progress={loadingScreen.progress} />
        <Logo name="swintt" position="bottom" />
      </Styled>
    );
  }
};

export default LoadingScreen;
